import { Component, computed, inject, signal, viewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DialogComponent } from '@joii/design-system';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { ClientService } from 'src/shared/services/client/client.service';
import { SelectModel } from '../forms/select/select_model';
import RegionDropdownComponent from './region-dropdown/region-dropdown.component';
import { RegionToastComponent } from './region-toast/region-toast.component';

@Component({
  selector: 'app-switchregion',
  templateUrl: './switchregion.component.html',
  imports: [RegionDropdownComponent, DialogComponent],
  host: {
    '[attr.data-automationid]': "'switchregion-form'",
  },
  styles: `
    ::ng-deep .switchregion-confirm-dialog .dialog-content {
      padding: 0 24px 24px 24px !important;
    }
  `,
})
export class SwitchRegionComponent {
  readonly client = inject(ClientService);
  readonly router = inject(Router);
  readonly toastService = inject(ToastrService);
  readonly region = signal(this.client.getRegion());
  options = this.getRegionOptions();
  regionFlag = computed(() => {
    return environment.regions.find((r) => r.code === this.region())?.flag ?? this.region();
  });
  regionName = computed(() => {
    return environment.regions.find((r) => r.code === this.region())?.name ?? this.region();
  });
  confirmDialog = viewChild<DialogComponent>('confirmDialog');

  getRegionOptions() {
    return environment.regions.map((region) => {
      return {
        value: region.code,
        name: region.name,
        data: {
          flag: region.flag,
        },
      } as SelectModel;
    });
  }

  onChangeRegion(region: string | undefined | null) {
    if (!region) {
      return;
    }
    this.confirmDialog()?.open();
  }

  refreshCurrentRoute(regionCode: string | undefined | null): void {
    if (!regionCode) {
      return;
    }
    const url = this.router.url;
    const regionName = environment.regions.find((r) => r.code === regionCode)?.name ?? regionCode;
    const regionFlag = environment.regions.find((r) => r.code === regionCode)?.flag ?? regionCode;
    this.client.setRegion(regionCode);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigateByUrl(url))
      .then(() => {
        this.toastService.show(
          `All data has been updated to show ${regionName} information.`,
          `You are now viewing ${regionFlag} ${regionName}`,
          {
            toastComponent: RegionToastComponent,
            toastClass: 'ngx-toastr region-toast',
            timeOut: 5000,
            positionClass: 'toast-bottom-right',
          }
        );
        this.confirmDialog()?.close();
      });
  }

  cancelConfirmDialog() {
    const oldRegion = this.client.getRegion();
    this.region.set(oldRegion);
    this.confirmDialog()?.close();
  }
}
